var _circle, _circle2, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQStampLastminuteInactive = function SvgQStampLastminuteInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#C9CCDE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 25,
    fill: "#C9CCDE",
    stroke: "#fff",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.447,
    height: 16.357,
    x: 21.276,
    y: 22.645,
    fill: "#EFF1F9",
    rx: 1.227
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.364 22.645h3.271v16.357h-3.271zM24.548 19.92c0-.273.264-.47.526-.391L30 21.007l4.926-1.478a.41.41 0 0 1 .526.392v2.721H24.548z"
  })));
};
export { SvgQStampLastminuteInactive as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzAiIGN5PSIzMCIgcj0iMzAiIGZpbGw9IiNDOUNDREUiLz4KPGNpcmNsZSBjeD0iMzAiIGN5PSIzMCIgcj0iMjUiIGZpbGw9IiNDOUNDREUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cmVjdCB4PSIyMS4yNzY0IiB5PSIyMi42NDQ1IiB3aWR0aD0iMTcuNDQ3MyIgaGVpZ2h0PSIxNi4zNTY4IiByeD0iMS4yMjY3NiIgZmlsbD0iI0VGRjFGOSIvPgo8cmVjdCB4PSIyOC4zNjQzIiB5PSIyMi42NDQ1IiB3aWR0aD0iMy4yNzEzNiIgaGVpZ2h0PSIxNi4zNTY4IiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjQuNTQ3OSAxOS45MjA3QzI0LjU0NzkgMTkuNjQ2OCAyNC44MTE5IDE5LjQ1MDMgMjUuMDc0MyAxOS41MjlMMzAuMDAwMSAyMS4wMDY4TDM0LjkyNiAxOS41MjlDMzUuMTg4MyAxOS40NTAzIDM1LjQ1MjQgMTkuNjQ2OCAzNS40NTI0IDE5LjkyMDdWMjIuNjQyNUgyNC41NDc5VjE5LjkyMDdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";